var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-chip-group', [_vm._l(_vm.items, function (item, index) {
    return [_c('v-chip', _vm._b({
      key: index,
      attrs: {
        "disabled": ""
      }
    }, 'v-chip', item, false), [_vm._v(" " + _vm._s(item.text) + " ")])];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }